import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=1d59874a&scoped=true&"
import script from "./SettingsList.vue?vue&type=script&lang=js&"
export * from "./SettingsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=1d59874a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59874a",
  null
  
)

export default component.exports